<dynamic-form
  *ngIf="isOkforLoad && formGroup"
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [model]="model"
  [areaName]="areaName"
  [columns]="columns"
  (valueChangeByApiName)="onValueChangeByApiName($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="footer">
    <ssg-button
      icon="icon-file-document-multiple-outline"
      buttontype="button"
      (click)="testConection()"
      class="login-btn"
      [label]="'ClientApp.GNR.Branch.ConnectionTest' | translate"
      size="medium"
      appearance="flat">
    </ssg-button>
  </ng-container>
</dynamic-form>
